package presentation.screens.business.onboard.create_business_screen

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.runtime.Composable
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import cafe.adriel.voyager.core.screen.Screen
import cafe.adriel.voyager.navigator.LocalNavigator
import component.button.DefaultButton
import component.navigation.TopNavBar
import component.stepper.StepsProgressBar
import feature.address.model.Address
import feature.business.viewModel.BusinessViewModel
import presentation.screens.business.onboard.create_business_screen.component.CreateBusinessAddress
import presentation.screens.business.onboard.create_business_screen.component.CreateBusinessBasicInfo
import theme.ThemeColor

class CreateBusinessScreen : Screen {
    val viewModel = BusinessViewModel()

    init {
        viewModel.createBusiness.value.Address = Address()
    }


    @Composable
    override fun Content() {
        val currentStep = remember { mutableStateOf(0) }
        val navigator = LocalNavigator.current
        fun onClickSave() {
            viewModel.createNewBusiness {
                navigator?.pop()
                navigator?.pop()
            }
        }
        Column(
            modifier = Modifier.fillMaxSize().background(ThemeColor.shared().defaultBakground)
        ) {
            TopNavBar(title = "Select Type of Business", onBackPress = {
                if (currentStep.value == 0) {
                    navigator?.pop()
                } else {
                    currentStep.value = currentStep.value - 1
                }
            })
            Box(
                modifier = Modifier.fillMaxWidth().height(40.dp).background(
                    ThemeColor.shared().cardBackground,
                    RoundedCornerShape(8.dp)
                ).padding(8.dp)
            ) {
                StepsProgressBar(
                    modifier = Modifier.fillMaxWidth(),
                    numberOfSteps = 3,
                    currentStep = currentStep.value
                )
            }
            if (currentStep.value == 0) {
                CreateBusinessBasicInfo(viewModel)
            } else if (currentStep.value == 1) {
                CreateBusinessAddress(viewModel)
            } else if (currentStep.value == 2) {
                CreateBusinessAddress(viewModel)
            }
            DefaultButton(if (currentStep.value == 2) "Save" else "Next", onClick = {
                if (currentStep.value == 1) {
                    onClickSave()
                } else {
                    currentStep.value = currentStep.value + 1
                }
            }, modifier = null)
        }
    }
}